import { render, staticRenderFns } from "./ClassItemView.vue?vue&type=template&id=14e53466"
import script from "./ClassItemView.vue?vue&type=script&lang=js"
export * from "./ClassItemView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports